export const getFallbackImageUrl = (): string => {
  return "/images/hotel-image-fallback-1.jpg";
};
